import React, { useEffect } from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import reduxThunk from 'redux-thunk';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import remInit from './lib/rem';

import 'antd/dist/antd.css';

import reducer from './redux/reducer';

import Home from './page/home/index';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  /* preloadedState, */ composeEnhancers(applyMiddleware(reduxThunk)),
);

const App = () => {
  useEffect(() => {
    remInit();
  }, []);
  return (
    <Router>
      <Provider store={store}>
        <Switch>
          <Route>
            <Home />
          </Route>
        </Switch>
      </Provider>
    </Router>
  );
};

export default App;
